import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import VideoPlayer from "./video_player.jsx"

import Paper from '@material-ui/core/Paper';

function TabContainer(props) {
  return (
    <Typography component="div">
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  tabContainer: {
      padding: 0,
  }
});

class TabsWrappedLabel extends React.Component {
  state = {
    value: 'annotated',
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { classes, video } = this.props;
    const { value } = this.state;

    const videoJsOptions = {
        autoplay: false,
        controls: true,
        fluid: true,
        preload: "none",
        poster: `https://img.youtube.com/vi/${video.fields.external_id}/mqdefault.jpg`,

        sources: [{
            src: video.fields.cloud_location,
        }]
    }

    const videoJsOptionsAnnotated = {
        autoplay: false,
        controls: true,
        fluid: true,
        preload: "none",
        poster: `https://img.youtube.com/vi/${video.fields.external_id}/mqdefault.jpg`,

        sources: [{
            src: video.renditions && video.renditions.length > 0 && video.renditions[0].fields.url,
        }]
    }


      console.log(video);

    return (
      <Paper className={classes.root}>
          <AppBar position="static">
            <Typography variant="title" color="inherit">Renditions</Typography>
          </AppBar>
        <AppBar position="static">
          <Tabs value={value} onChange={this.handleChange}>
            <Tab value="annotated" label="Annotated" />
            <Tab value="original" label="Original" />
          </Tabs>
        </AppBar>
        {value === 'annotated' && (
            <TabContainer className={classes.tabContainer}>
                <VideoPlayer { ...videoJsOptionsAnnotated } />
            </TabContainer>
        )}
        {value === 'original' && (
            <TabContainer className={classes.tabContainer}>
                <VideoPlayer { ...videoJsOptions } />
            </TabContainer>
        )}
      </Paper>
    );
  }
}

TabsWrappedLabel.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TabsWrappedLabel);



// WEBPACK FOOTER //
// ./src/components/renditions.jsx